import { Outlet, Link } from 'react-router-dom';
import { LogOut, ExternalLink } from 'lucide-react';

function CottonCubsLogo({ size = 44 }) {
  const r = 44;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <circle cx="50" cy="50" r={r} fill="white" fillOpacity=".9"/>
      <circle cx="50" cy="50" r={r} stroke="#c9907a" strokeWidth="1.2" strokeDasharray="3.5 4.5" fill="none"/>
      <circle cx="50" cy="50" r="38" stroke="#c9907a" strokeWidth=".5" fill="none" opacity=".35"/>
      {[0,45,90,135,180,225,270,315].map(deg => {
        const x = 50 + r * Math.cos((deg-90)*Math.PI/180);
        const y = 50 + r * Math.sin((deg-90)*Math.PI/180);
        return <circle key={deg} cx={x} cy={y} r="1.6" fill="#c9907a" opacity=".6"/>;
      })}
      <text x="50" y="44" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#3d2416" fontStyle="italic" fontWeight="600">Cotton</text>
      <text x="50" y="58" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#3d2416" fontStyle="italic" fontWeight="600">Cubs</text>
      <text x="50" y="68" textAnchor="middle" fontFamily="Georgia,serif" fontSize="5" fill="#7a5040" letterSpacing="2.5" opacity=".7">ORGANIC CLOTHING</text>
    </svg>
  );
}

export default function AdminLayout({ onLogout }) {
  return (
    <div style={{ fontFamily: "'Nunito',sans-serif", background: '#faf6f0', minHeight: '100vh' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;1,600&family=Nunito:wght@300;400;500;600;700;800;900&display=swap');
        .admin-topbar { background: #fff; border-bottom: 1px solid #ede3d5; padding: 0 24px; height: 60px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 100; }
        .admin-btn { border: none; cursor: pointer; font-family: 'Nunito',sans-serif; font-weight: 700; font-size: 13px; border-radius: 8px; padding: 8px 16px; transition: all .2s; display: inline-flex; align-items: center; gap: 6px; }
        .admin-btn-primary { background: #c0735a; color: #fff; }
        .admin-btn-primary:hover { background: #5c3d2e; }
        .admin-btn-ghost { background: transparent; color: #7a5c4a; }
        .admin-btn-ghost:hover { background: #f5efe4; color: #c0735a; }
        .admin-link { text-decoration: none; color: #7a5c4a; font-weight: 700; font-size: 13px; display: inline-flex; align-items: center; gap: 5px; transition: color .2s; }
        .admin-link:hover { color: #c0735a; }
        .admin-content { max-width: 1200px; margin: 0 auto; padding: 28px 24px; }
      `}</style>
      <div className="admin-topbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Link to="/admin" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
            <CottonCubsLogo size={36} />
            <span style={{ fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 700, color: '#3d2b1f', fontStyle: 'italic' }}>Admin</span>
          </Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <Link to="/" className="admin-link" target="_blank"><ExternalLink size={14} /> View Store</Link>
          <button className="admin-btn admin-btn-ghost" onClick={onLogout}><LogOut size={14} /> Logout</button>
        </div>
      </div>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
}
